(function ($) {
    const behavior = 'polyu_theme.views-offers';
    Drupal.behaviors[behavior] = {
        attach: (context, settings) => {
            offers_filter_toggle_select2();
            context.querySelectorAll('.container--view--offers .offers-wrapper').forEach(pattern => {
                offers_toggle_collapsible(pattern);
            })
        },
    };
    
    $(function () {
    });
    
    function offers_filter_toggle_select2 () {
        if($('.container--view--offers select').length > 0) {
            $('.container--view--offers select').select2();
        }
    }
    
    function offers_toggle_collapsible(pattern) {
        const items = pattern.querySelectorAll('.views-row');
        if (items.length === 0) return;
        
        const toggle = (item, state) => {
            item.classList.toggle('active', state);
        }
        
        items.forEach((item, i) => {
            const arrow = item.querySelector('.views-field-title');
            if (arrow === null) return;
            
            arrow.onclick = function () {
                let active = [...pattern.querySelectorAll('.views-row.active')];
                var otherActiveElements = active.filter(function (element) {
                    return element !== item;
                });
                for (let j = 0; j < otherActiveElements.length; j++) {
                    var active_content = active[j].querySelector('.views-field-title').nextElementSibling;
                    active_content.style.maxHeight = null;
                    active[j].classList.remove('active');
                }
                item.classList.toggle('active');
                
                var isOpen_content = arrow.nextElementSibling;
                if (isOpen_content.style.maxHeight) {
                    isOpen_content.style.maxHeight = null;
                } else {
                    isOpen_content.style.maxHeight = isOpen_content.scrollHeight + "px";
                }
            }
        });
    }
})(jQuery);
